import React, { Component } from 'react';
import * as Constants from '../../common/Global/constants';
import {SearchSpan, AddNewButtonLayout, TableCheckBox, DialogSaveButton, ResouceAddButton, TableIcon} from '../../common/Global/globalStyles.style';
import FilterDropDown from '../../common/DropdownMenus/FilterDropdown';
import AlertDialog from '../../common/AlertDialog';
import Pagination from '../../common/Global/pagination';
import {
    BrowserRouter as Router,
} from 'react-router-dom';
import {getLocalStorageVariables,isEmptyVariable,sortTable,
    isEmptyArray,
    handleTokenExpiry,
    getThemeSettingsVariables,
    isJsonString} from '../../common/Global/commonFunctions';
import Sidebar from '../../common/Sidebar';
import Topbar from '../../common/Topbar';
import ClientTabs from './topmenu';
import * as TemplateConstants from '../../common/Global/templateConstants';

let userDetails = {};
let themeSettings = getThemeSettingsVariables();

const sortDashboardName = "d.dashboardName";
const sortDescription = "d.description";
const sortRootExecuteTemplateId = "d.rootExecuteTemplateId";

class AddClientDashboard extends Component {
    constructor(props) {
        super(props);
        const item = props.location.state;
        this.state = {
            componentDidMountFlag:false,
            apiSearchKey:"",
            clientSearchkey:"",
            currentPageNo: 1,
            showLoader:false,
            resultSize:Constants.RESULT_SIZE,
            totalCount:0,
            datalist:[],
            resultSizePlaceholder:Constants.RESULT_SIZE,
            sort:sortDashboardName,
            sortDir:"asc",

            status:"Active",
            resultSizeArr:Constants.RESULT_SIZE_DD_ARR,
            
            showAlertDialogInfo: false,
			alertDialogMessageInfo: "",
            selectedDashboardId:[],
            
            clientId:parseInt(item?.clientId) ?? "",
            departmentArr:item?.departmentArr ?? [],
            dashboardList: [],
            companyName:item?.companyName ?? "",
            editingRowId: null
        }
    }

    componentDidMount(){
        userDetails = getLocalStorageVariables();
        themeSettings = getThemeSettingsVariables();
        this.getInitData();
    }

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    onSearchIconClick = () => {
        this.getDashboardsList();
    }

    onEnterBtnPress = (e) => {
        var code = e.keyCode || e.which;
        if(code === 13){
            this.getDashboardsList();
        }
    }

    handleAlertDialogCloseInfo = () => {
		this.setState({
			showAlertDialogInfo: false,
			alertDialogMessageInfo: "",
		});
	};
    
    resultSizeDropdownClick = (item,selectedIndex) => {
        let tempArr = this.state.resultSizeArr;
        let placeholder = "";

        for(const [i,value] of tempArr.entries()){
            if(i === selectedIndex){
                tempArr[i].isSelected = true;
                placeholder = value.label ;
            }else{
                tempArr[i].isSelected = false;
            }
        }
        
        this.setState({
            resultSizeArr:tempArr,
            resultSize:item.label,
            resultSizePlaceholder:placeholder
        },() => {
            this.getDashboardsList();
        })
    }

    sortTableLocal = (sortColumn) => {
        let sortObj = sortTable(sortColumn,this.state.sort,this.state.sortDir);

        this.setState({
            sort:sortObj.sortTemp,
            sortDir:sortObj.sortDirTemp,
        },()=>{
            this.getDashboardsList();
        })
    }

    handleStopPropagation = (e) => {
        e.stopPropagation();
    }

    handleSelection = (item, e) => {
        e.stopPropagation();
        let dashboardId = item.dashboardId;
        let isChecked = e.target.checked;
        let newDataList = this.state.datalist;

        newDataList.map((item)=>{
            if(item.dashboardId == dashboardId) {
                item.isChecked = isChecked;
            }
        })

        let selectedDashboardId = this.state.selectedDashboardId;

        if(isChecked){
            selectedDashboardId.push(dashboardId)
        } else {
            selectedDashboardId = selectedDashboardId.filter(item=>item != dashboardId);
        }

        //check whether all the list item are selected
        let atleastOneNotSelected = newDataList.some(item => !item.isChecked)
        
        this.setState({
            dataList: newDataList,
            selectedDashboardId: selectedDashboardId,
            isSelctAllChecked:!atleastOneNotSelected,
        });
    }

    onCancelButtonClick = () => {
        this.props.history.goBack();
    }

    handleClientInputChange = (e, idx, field) => {
        const value = e.target.value;
        let datalist = [...this.state.datalist];
        datalist.map((item, index) => {
            if(idx === index){
                item[field] = value;
                item.isEdit = true;
                return item;
            }
        })
        this.setState({ datalist });
    };

    handleEditIconClick = (item) => {
        this.setState({
            editingRowId: item.dashboardId
        });
    }
    
    handleCancelEditClick = () => {
        this.setState({
            editingRowId: null,
            formErrors: {}
        });
    }

    /*******************API CALLS*******************/
    getInitData = () => {
        this.setState({
            showLoader:true,
        });
        // let templatePostParam = {
        //     email: userDetails.email,
        //     accessToken: userDetails.accessToken,
        //     templateType:TemplateConstants.TEMPLATE_TYPE_EX_TASK,
        //     clientId:this.state.clientId
        // }
        const departmentIds = this.state.departmentArr.departmentId;
        Promise.all([
            fetch(Constants.Dashboards,
            {
                method: "POST",
                mode:'cors',
                body: new URLSearchParams({
                    email:userDetails.email,
                    accessToken:userDetails.accessToken,
                    pageNo:this.state.currentPageNo,
                    search:this.state.clientSearchkey,
                    resultsize:this.state.resultSize,
                    status:this.state.status,
                    sort:this.state.sort,
                    sortDir:this.state.sortDir
                })
            }),
            fetch(Constants.Dashboards+"/"+this.state.clientId,
            {
                method: "POST",
                mode:'cors',
                body: new URLSearchParams({
                    email:userDetails.email,
                    accessToken:userDetails.accessToken,
                    pageNo:'',
                    search:this.state.clientSearchkey,
                    resultsize:this.state.resultSize,
                    status:this.state.status,
                    sort:this.state.sort,
                    sortDir:this.state.sortDir,
                    departmentIdList:JSON.stringify(departmentIds)
                })
            }),
            // fetch(Constants.GetTemplates, {
            //     method: "POST",
            //     mode: "cors",
            //     body: new URLSearchParams(templatePostParam),
            // }),
        ])
        .then(([dashboardRes, clientDashbaordRes]) => {
            return Promise.all([dashboardRes.json(), clientDashbaordRes.json()]);
        })
        .then(([dashboardRes, clientDashboardRes]) => {
            // let templateList = [];
            // if(handleTokenExpiry(templateRes.responseCode)) return;
            // else if(templateRes.responseCode === Constants.CODE_SUCCESS){
            //     templateList = templateRes.data.result;
            // }
            let dashboardList = [];
            let clientDashboardList = [];
            let totalCount = 0;
            if(handleTokenExpiry(dashboardRes.responseCode)) return;
            else if(dashboardRes.responseCode === Constants.CODE_SUCCESS){
                dashboardList = dashboardRes.data.dashboardList;
                totalCount = dashboardRes.data.totalCount;
            }else{
                
            }

            if(handleTokenExpiry(clientDashboardRes.responseCode)) return;
            else if(clientDashboardRes.responseCode === Constants.CODE_SUCCESS){
                clientDashboardList = clientDashboardRes.data.clientDashboardList;
            }else{
                
            }

            if(!isEmptyArray(dashboardList)){
                dashboardList = dashboardList.map(item => {
                    const matchedClientDashboard = !isEmptyArray(clientDashboardList) 
                        ? clientDashboardList.find(e => {
                            const deptList = Array.isArray(e.departmentList)
                                ? e.departmentList
                                : (isJsonString(e.departmentList) ? JSON.parse(e.departmentList) : []);
                            return (
                                e.dashboardId+"" === item.dashboardId+"" &&
                                !isEmptyArray(deptList) &&
                                deptList.some(dept => dept?.departmentId+"" === this.state.departmentArr?.departmentId+"")
                            );
                        })
                        : null;

                    return {
                        ...item,
                        dashboardClientId: matchedClientDashboard?.dashboardClientId || "",
                        dashboardClientName: matchedClientDashboard?.dashboardClientName || "",
                        dashboardClientDescription: matchedClientDashboard?.dashboardClientDescription || "",
                        clientsFieldConfig: matchedClientDashboard?.clientsFieldConfig || ""
                    }
                })
            }

            this.setState({
                showLoader:false,
                componentDidMountFlag:true,
                datalist:dashboardList,
                totalCount:totalCount,
                apiSearchKey:this.state.clientSearchkey,
                dashboardList:clientDashboardList,
            })
        });
    }

    onChangePage = (page) => {
        // update state with new page of items
        userDetails  = getLocalStorageVariables();
        if(page !== this.state.currentPageNo){
            this.setState({
                showLoader:true,
            });
            
            fetch(Constants.Dashboards,
            {
                method: "POST",
                mode:'cors',
                body: new URLSearchParams({
                    email:userDetails.email,
                    accessToken:userDetails.accessToken,
                    pageNo:page,
                    search:this.state.clientSearchkey,
                    resultsize:this.state.resultSize,
                    status:this.state.status,
                    sort:this.state.sort,
                    sortDir:this.state.sortDir
                })
            })
            .then(response => { return response.json(); } )
            .then(data =>
            {
                if(handleTokenExpiry(data.responseCode)) return;
                else if(data.responseCode === Constants.CODE_SUCCESS){
                    let dashboardList = data.data.dashboardList;

                    if(!isEmptyArray(dashboardList)){
                        dashboardList = dashboardList.map(item => {
                            const matchedClientDashboard = !isEmptyArray(this.state.dashboardList) 
                                ? this.state.dashboardList.find(e => {
                                    const deptList = Array.isArray(e.departmentList)
                                        ? e.departmentList
                                        : (isJsonString(e.departmentList) ? JSON.parse(e.departmentList) : []);
                                    return (
                                        e.dashboardId+"" === item.dashboardId+"" &&
                                        !isEmptyArray(deptList) &&
                                        deptList.some(dept => dept?.departmentId+"" === this.state.departmentArr?.departmentId+"")
                                    );
                                })
                                : null;

                            return {
                                ...item,
                                dashboardClientId: matchedClientDashboard?.dashboardClientId || "",
                                dashboardClientName: matchedClientDashboard?.dashboardClientName || "",
                                dashboardClientDescription: matchedClientDashboard?.dashboardClientDescription || "",
                                clientsFieldConfig: matchedClientDashboard?.clientsFieldConfig || ""
                            }
                        })
                    }
                    this.setState({
                        showLoader:false,
                        componentDidMountFlag:true,
                        datalist:dashboardList,
                        totalCount:data.data.totalCount,
                        apiSearchKey:this.state.clientSearchkey,
                        currentPageNo:page,
                    })
                }else{
                    this.setState({
                        datalist:[],
                        showLoader:false,
                        componentDidMountFlag:true,
                        apiSearchKey:this.state.clientSearchkey,
                    })
                }
            });
        }
    }

    getDashboardsList = (reloadFlag) => {
        this.setState({
            showLoader:true,
        });
        fetch(Constants.Dashboards,
        {
            method: "POST",
            mode:'cors',
            body: new URLSearchParams({
                email:userDetails.email,
                accessToken:userDetails.accessToken,
                pageNo:this.state.currentPageNo,
                search:this.state.clientSearchkey,
                resultsize:this.state.resultSize,
                status:this.state.status,
                sort:this.state.sort,
                sortDir:this.state.sortDir
            })
        })
        .then(response => { return response.json(); } )
        .then(data =>
        {
            if(handleTokenExpiry(data.responseCode)) return;
            else if(data.responseCode === Constants.CODE_SUCCESS){
                let dashboardList = data.data.dashboardList;
                if(!isEmptyArray(dashboardList)){
                    dashboardList = dashboardList.map(item => {
                        const matchedClientDashboard = !isEmptyArray(this.state.dashboardList) 
                            ? this.state.dashboardList.find(e => {
                                const deptList = Array.isArray(e.departmentList)
                                    ? e.departmentList
                                    : (isJsonString(e.departmentList) ? JSON.parse(e.departmentList) : []);
                                return (
                                    e.dashboardId+"" === item.dashboardId+"" &&
                                    !isEmptyArray(deptList) &&
                                    deptList.some(dept => dept?.departmentId+"" === this.state.departmentArr?.departmentId+"")
                                );
                            })
                            : null;
                        return {
                            ...item,
                            dashboardClientId: matchedClientDashboard?.dashboardClientId || "",
                            dashboardClientName: matchedClientDashboard?.dashboardClientName || "",
                            dashboardClientDescription: matchedClientDashboard?.dashboardClientDescription || "",
                            clientsFieldConfig: matchedClientDashboard?.clientsFieldConfig || ""
                        }
                    })
                }

                this.setState({
                    showLoader:false,
                    componentDidMountFlag:true,
                    dashboardList:dashboardList,
                    totalCount:data.data.totalCount,
                    apiSearchKey:this.state.clientSearchkey
                },() => {
                    if(reloadFlag === true){
                        this.getClientDashboardsList();
                    }
                })
            }else{
                this.setState({
                    dashboardList:[],
                    totalCount:0,
                    showLoader:false,
                    componentDidMountFlag:true,
                    apiSearchKey:this.state.clientSearchkey,
                })
            }
        });
    }
    
    handleSaveButtonClick = () => {
        this.setState({
            showBtnLoader:true,
        });
        const departmentArr = this.state.departmentArr;
        let formErrors = {};
        let hasError = false;
        const assignedDashboardList = this.state.datalist
            .filter(item => item.isChecked === true)
            .map(item => {
                if (!item.dashboardClientName || item.dashboardClientName.trim() === "") {
                    formErrors[`${item.dashboardId}_name`] = "Client's Name is required.";
                    hasError = true;
                }
                if (!item.dashboardClientDescription || item.dashboardClientDescription.trim() === "") {
                    formErrors[`${item.dashboardId}_description`] = "Client's Description is required.";
                    hasError = true;
                }
                return {
                    dashboardId: item.dashboardId,
                    departmentId: departmentArr.departmentId,
                    dashboardClientName: item.dashboardClientName || "",
                    dashboardClientDescription: item.dashboardClientDescription || "",
                    apiName: item.apiName || "",
                    rootExecuteTemplateId: item.rootExecuteTemplateId || 0,
                    clientsFieldConfig: JSON.stringify(item.clientsFieldConfig) || JSON.stringify({"auditee":true})
                };
            });
        if (hasError) {
            this.setState({
                showBtnLoader: false,
                formErrors: formErrors
            });
            return;
        }
        if (assignedDashboardList.length === 0) {
            this.setState({
                showBtnLoader: false,
                showAlertDialogInfo: true,
                alertDialogMessageInfo: "Please select at least one dashboard to save."
            });
            return;
        }
        fetch(Constants.Dashboards+"/"+this.state.clientId+"/assign",
        {
            method: "POST",
            mode:'cors',
            body: new URLSearchParams({
                email:userDetails.email,
                accessToken:userDetails.accessToken,
                clientId:this.state.clientId,
                assignedDashboardList:JSON.stringify(assignedDashboardList)
            })
        })
        .then(response => { return response.json(); } )
        .then(data =>
        {
            if(handleTokenExpiry(data.responseCode)) return;
            else if(data.responseCode === Constants.CODE_SUCCESS){
                this.props.history.goBack();
                this.setState({
                    showBtnLoader:false,
                })
            }else{
                this.setState({
                    showBtnLoader:false,
                })
            }
        });
    }

    handleUpdateButtonClick = (item) => {
        let formErrors = {};
        let hasError = false;
        if(isEmptyVariable(item.dashboardClientName)){
            formErrors[`${item.dashboardId}_name`] = "Client's Name is required.";
            hasError = true;
        }
        if(isEmptyVariable(item.dashboardClientDescription)){
            formErrors[`${item.dashboardId}_description`] = "Client's Description is required.";
            hasError = true;
        }
        if (hasError) {
            this.setState({
                formErrors: formErrors
            });
            return;
        }
        fetch(Constants.Dashboards+"/"+this.state.clientId+"/update/"+item.dashboardClientId,
        {
            method: "POST",
            mode:'cors',
            body: new URLSearchParams({
                email:userDetails.email,
                accessToken:userDetails.accessToken,
                dashboardClientName: item.dashboardClientName || "",
                dashboardClientDescription: item.dashboardClientDescription || "",
                clientsFieldConfig: JSON.stringify(item.clientsFieldConfig) || JSON.stringify({"auditee":true}),
                apiName: item.apiName || "",
                rootExecuteTemplateId: item.rootExecuteTemplateId || 0,
            })
        })
        .then(response => { return response.json(); } )
        .then(data =>
        {
            if(handleTokenExpiry(data.responseCode)) return;
            else if(data.responseCode === Constants.CODE_SUCCESS){
                this.getDashboardsList(true);
                this.setState({
                    editingRowId: null
                });
            }else{
            }
        });
    }

    getClientDashboardsList = () => {
        const departmentIds = this.state.departmentArr.departmentId;
        fetch(Constants.Dashboards+"/"+this.state.clientId,
        {
            method: "POST",
            mode:'cors',
            body: new URLSearchParams({
                email:userDetails.email,
                accessToken:userDetails.accessToken,
                pageNo:'',
                search:this.state.clientSearchkey,
                resultsize:this.state.resultSize,
                status:this.state.status,
                sort:this.state.sort,
                sortDir:this.state.sortDir,
                departmentIdList:JSON.stringify(departmentIds)
            })
        })
        .then(response => { return response.json(); } )
        .then(data =>
        {
            if(handleTokenExpiry(data.responseCode)) return;
            else if(data.responseCode === Constants.CODE_SUCCESS){
                this.setState({
                    dashboardList:data.data.clientDashboardList
                })
            }else{
            }
        });
    }

    handleDeleteButtonClick = (dashboardClientId) => {
        fetch(Constants.Dashboards+"/"+this.state.clientId+"/remove/"+dashboardClientId,
        {
            method: "POST",
            mode:'cors',
            body: new URLSearchParams({
                email:userDetails.email,
                accessToken:userDetails.accessToken
            })
        })
        .then(response => { return response.json(); } )
        .then(data =>
        {
            if(handleTokenExpiry(data.responseCode)) return;
            else if(data.responseCode === Constants.CODE_SUCCESS){
                // this.props.history.goBack();
                // let dashboardList = this.state.dashboardList;
                // dashboardList = dashboardList.filter(item => item.dashboardClientId !== dashboardClientId);
                // this.setState({
                //     dashboardList:dashboardList
                // },()=>{
                    // })
                this.getDashboardsList(true);
            }else{
                this.setState({
                    showAlertDialogInfo:true,
                    alertDialogMessageInfo:data.responseMessage
                })
            }
        });
    }

    handleVerifyButtonClick = () => {
        
    }

    /*******************API CALLS END HERE*******************/

    render() {
        return(
            <Router>
				<main className="main-dashboard">
                    <section className="dashboard-bg">
                        <Sidebar />
                        <div className="dashboard-right-bg position-relative">
						    <div className="dashboard-wrapper">
                                <Topbar />
                                <ClientTabs
                                    clientId={this.state.clientId}
                                    displayingClients={true}
                                    displayingTemplates={false}
                                    companyName={this.state.companyName}
                                    themeSettings = {themeSettings}
                                    showInfo={false}
                                />
                                {
                                    this.state.showLoader &&
                                    <div class="loader"></div>
                                }
                                {
                                    // Need to check component did mount flag, other wise until api is called,
                                    // it shows no items found layout.
                                    this.state.componentDidMountFlag &&
                                    <div className="body-wrapper">
                                        <div className="search-addnew-bg">
                                            <div className="search-addnew">
                                                <div className="search-filter-layout">
                                                    <FilterDropDown
                                                        placeholder={this.state.resultSizePlaceholder}
                                                        dropdownArr={this.state.resultSizeArr}
                                                        onDropDownItemClick={this.resultSizeDropdownClick}
                                                        themeSettings={themeSettings}
                                                        mleft={0}
                                                    />
                                                    <div className="search-col m-l-10">
                                                        <input 
                                                            name="clientSearchkey" 
                                                            type="text"
                                                            onChange={this.handleChange}
                                                            placeholder="Search" 
                                                            onKeyPress={this.onEnterBtnPress}
                                                            value={this.state.clientSearchkey} 
                                                        />
                                                        <SearchSpan 
                                                            className="material-icons"
                                                            themeSettings={themeSettings}
                                                            onClick = {this.onSearchIconClick}>
                                                                search
                                                        </SearchSpan>
                                                    </div>
                                                    <span style={{fontSize:13, marginLeft:10}}>{this.state.departmentArr?.name}</span>
                                                </div>
                                            </div>
                                        </div>
                                        {
                                            !isEmptyArray(this.state.datalist) && 
                                            <div className="common-tab-bg">
                                                <div className="common-table" style={{width:"100%"}}>
                                                <table className="table">
                                                    <thead>
                                                        <tr>
                                                            <th width={"5%"}></th>
                                                            {/* <th className="text-center" width={"5%"}>No</th> */}
                                                            <th className="c-pointer" onClick={this.sortTableLocal.bind(this,sortDashboardName)}>
                                                                <div className="sort-header">Name
                                                                    <span className={(this.state.sort === sortDashboardName)?"material-icons":"material-icons hide-sort-arrow"}>{this.state.sortDir === "asc"?"arrow_upward":"arrow_downward"}</span>
                                                                </div>
                                                            </th>
                                                            <th className="c-pointer" onClick={this.sortTableLocal.bind(this,sortDescription)}>
                                                                <div className="sort-header">Description
                                                                    <span className={(this.state.sort === sortDescription)?"material-icons":"material-icons hide-sort-arrow"}>{this.state.sortDir === "asc"?"arrow_upward":"arrow_downward"}</span>
                                                                </div>
                                                            </th>
                                                            <th>
                                                                <div className="sort-header">Client's Name*</div>
                                                            </th>
                                                            <th>
                                                                <div className="sort-header">Client's Description*</div>
                                                            </th>
                                                            <th width={"10%"}>
                                                                <div className="sort-header">Execute Id</div>
                                                            </th>
                                                            <th width={"12%"}>
                                                                <div className="sort-header">Template Name</div>
                                                            </th>
                                                            <th></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            !isEmptyArray(this.state.datalist) && 
                                                            this.state.datalist.map((item,idx) => {
                                                                const dashboardList = !isEmptyArray(this.state.dashboardList) &&
                                                                this.state.dashboardList.filter(e => {
                                                                    let deptList = Array.isArray(e.departmentList)
                                                                        ? e.departmentList
                                                                        : (isJsonString(e.departmentList) ? JSON.parse(e.departmentList) : []);
                                                                    return (
                                                                        e.dashboardId+"" === item.dashboardId+"" &&
                                                                        (!isEmptyArray(deptList) &&
                                                                        deptList.some(dept => dept?.departmentId+"" === this.state.departmentArr?.departmentId+""))
                                                                    );
                                                                }) || [];
                                                                const isEditMode = this.state.editingRowId === item.dashboardId;

                                                                return <tr key={item.dashboardId} onMouseEnter={() => this.setState({hoveredRowId: item.dashboardId})} onMouseLeave={() => this.setState({hoveredRowId: null})}>
                                                                    {item.isCustomisable === "N" ?
                                                                        (!isEmptyArray(dashboardList) ?
                                                                            <td>
                                                                                {/* <TableIcon className="text-center" themeSettings={themeSettings}> */}
                                                                                    <span 
                                                                                        onClick={this.handleDeleteButtonClick.bind(this,dashboardList[0].dashboardClientId)} 
                                                                                        className="material-icons dashboard-edit-icons">
                                                                                        delete
                                                                                    </span>
                                                                                {/* </TableIcon> */}
                                                                            </td>
                                                                        :
                                                                        <td>
                                                                            <TableCheckBox onClick={this.handleStopPropagation} themeSettings={themeSettings}>
                                                                                <input 
                                                                                    type="checkbox"
                                                                                    name={idx}
                                                                                    id={item.dashboardId}
                                                                                    onChange={this.handleSelection.bind(this, item)}
                                                                                    checked={item.isChecked?true:false}
                                                                                />
                                                                                <label for={item.dashboardId} 
                                                                                style={{marginLeft:2}}></label>
                                                                            </TableCheckBox>
                                                                        </td>)
                                                                        :
                                                                        <td>
                                                                            <ResouceAddButton
                                                                                themeSettings={themeSettings}
                                                                                onClick={this.handleVerifyButtonClick}
                                                                                type="button"
                                                                                className="modal-save m-b-0"
                                                                            >
                                                                                Verify
                                                                            </ResouceAddButton>
                                                                        </td>
                                                                    }
                                                                    {/* <td className="text-center">{((this.state.currentPageNo - 1) * this.state.resultSize) + (++idx)}</td> */}
                                                                    <td>{item.dashboardName}</td>
                                                                    <td>{item.description}</td>
                                                                    <td>
                                                                        {(item.isCustomisable === "N" && !isEmptyArray(dashboardList) && !isEditMode) ?
                                                                            dashboardList[0].dashboardClientName
                                                                        :
                                                                            <div className="addnew-modal-form-group" style={{marginTop:3, marginBottom:3}}>
                                                                                <input
                                                                                    type="text"
                                                                                    placeholder="Enter Client's Name"
                                                                                    spellCheck="true"
                                                                                    name="dashboardClientName"
                                                                                    value={item.dashboardClientName || ""}
                                                                                    onChange={(e) => this.handleClientInputChange(e, idx, "dashboardClientName")}
                                                                                />
                                                                                {this.state.formErrors && this.state.formErrors[`${item.dashboardId}_name`] && (
                                                                                    <span className="cm-error">{this.state.formErrors[`${item.dashboardId}_name`]}</span>
                                                                                )}
                                                                            </div>
                                                                        }
                                                                    </td>
                                                                    <td>
                                                                        {(item.isCustomisable === "N" && !isEmptyArray(dashboardList) && !isEditMode) ?
                                                                            dashboardList[0].dashboardClientDescription
                                                                        :
                                                                            <div className="addnew-modal-form-group" style={{marginTop:3, marginBottom:3}}>
                                                                                <input
                                                                                    type="text"
                                                                                    placeholder="Enter Client's Description"
                                                                                    spellCheck="true"
                                                                                    name="dashboardClientDescription"                                                                                    value={item.dashboardClientDescription || ""}
                                                                                    onChange={(e) => this.handleClientInputChange(e, idx, "dashboardClientDescription")}
                                                                                />
                                                                                {this.state.formErrors && this.state.formErrors[`${item.dashboardId}_description`] && (
                                                                                    <span className="cm-error">{this.state.formErrors[`${item.dashboardId}_description`]}</span>
                                                                                )}
                                                                            </div>
                                                                        }
                                                                    </td>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td>
                                                                        {isEditMode ? (
                                                                            <div style={{display: 'flex', gap: '8px'}}>
                                                                                <span
                                                                                    onClick={this.handleUpdateButtonClick.bind(this, item)}
                                                                                    className="material-icons mx-2 dashboard-edit-icons"
                                                                                    style={{fontSize: 18, cursor: 'pointer'}}
                                                                                >
                                                                                    add_circle
                                                                                </span>
                                                                                <span
                                                                                    onClick={this.handleCancelEditClick}
                                                                                    className="material-icons mx-2 dashboard-edit-icons"
                                                                                    style={{fontSize: 18, cursor: 'pointer'}}
                                                                                >
                                                                                    cancel
                                                                                </span>
                                                                            </div>
                                                                        ): (
                                                                            <span
                                                                                onClick={this.handleEditIconClick.bind(this,item)}
                                                                                className="material-icons mx-2 dashboard-edit-icons"
                                                                                style={{
                                                                                    fontSize: 18, 
                                                                                    cursor: 'pointer', 
                                                                                    transition: 'opacity 0.3s ease',
                                                                                    opacity: this.state.hoveredRowId === item.dashboardId ? 1 : 0,
                                                                                    visibility: this.state.hoveredRowId === item.dashboardId ? 'visible' : 'hidden'
                                                                                }}
                                                                            >
                                                                                edit
                                                                            </span>
                                                                        )}
                                                                    </td>
                                                                </tr>
                                                            })
                                                        }
                                                    </tbody>
                                                </table>
                                            
                                                </div>
                                            </div>
                                        }
                                        {
                                            this.state.componentDidMountFlag && isEmptyArray(this.state.datalist) &&
                                            <div class="no-items-layout">
                                                <div class="no-items-card">
                                                    <h6>
                                                    {
                                                        isEmptyVariable(this.state.apiSearchKey)?
                                                        Constants.NO_RECORDS_WARNING
                                                        :
                                                        Constants.EMPTY_SEARCH_WARNING
                                                    }
                                                    </h6>
                                                </div>
                                            </div>
                                        }
                                        <div className="pagination-layout">
                                            <div className="row custom-row">
                                                <div className="col-md-9 custom-col">
                                                {
                                                    (this.state.totalCount > this.state.datalist.length) && 
                                                    <Pagination 
                                                        totalLength ={this.state.totalCount} 
                                                        items={this.state.datalist} 
                                                        onChangePage={this.onChangePage} 
                                                        pageSize={this.state.resultSize}
                                                        currentPageNo = {this.state.currentPageNo}
                                                        initialPage={this.state.currentPageNo} 
                                                        themeSettings={themeSettings}/>
                                                }
                                                </div>
                                                <div className="col-md-3 custom-col">
                                                    <p>{"Total Records: "+this.state.totalCount}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="modal-close-save m-t-15 footer-actions">
                                            <div className="close-save-col">
                                                <button
                                                    onClick={this.onCancelButtonClick}
                                                    type="button"
                                                    className="modal-close m-b-0"
                                                >
                                                    Cancel
                                                </button>
                                                <DialogSaveButton
                                                    themeSettings={themeSettings}
                                                    onClick={this.handleSaveButtonClick}
                                                    type="button"
                                                    className="modal-save m-b-0"
                                                >
                                                    Save
                                                </DialogSaveButton>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>

                        <AlertDialog
                            showAlertDialog={this.state.showAlertDialogInfo}
                            handleAlertDialogClose={this.handleAlertDialogCloseInfo}
                            type={Constants.ALERT_TYPE_ALERT}
                            alertDialogMessage={this.state.alertDialogMessageInfo}
                            proceedBtnClick={this.handleAlertDialogCloseInfo}
                            proceedBtnLabel={Constants.ALERT_TYPE_OKAY_LABEL}
                            themeSettings={themeSettings}
                        />
                    </section>
                </main>
            </Router>
        );
    }
}

export default AddClientDashboard;